<template>
  <div class="kr-layout-content">
    <!--账户管理-->
    <div class="publish">
      <div class="publish-top">
        <ul class="per-list">
          <li class="active">账户管理</li>
        </ul>
        <!-- <ul class="total">
          <li>
            今日发布数量：
            <span>0</span> / 6
          </li>
          <li>发文规范</li>
        </ul>-->
      </div>
      <ul class="account-data">
        <li>
          <label>帐号名称</label>
          <input type="text" placeholder v-model="cont.accountName" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
        <li>
          <label>帐号介绍</label>
          <input type="text" placeholder v-model="cont.accountIntroduce" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
        <li class="icon">
          <label>帐号头像</label>
          <div class="icon-img">
            <img :src="cont.accountPic" alt />
          </div>
          <input type="file" id="head" @change="getHead($event)" hidden />
          <label class="change" for="head">
            <img src="../../assets/img/change.png" alt />修改
          </label>
        </li>
        <li>
          <label>帐号类型</label>
          <input type="text" placeholder v-model="type" disabled />
        </li>
        <li v-if="false">
          <label>组织名称</label>
          <input type="text" placeholder v-model="cont.teamName" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
        <li v-if="false" class="icon">
          <label>组织机构代码证/营业执照</label>
          <div class="icon-img">
            <img :src="cont.businessLicense" alt />
          </div>
          <input type="file" id="business" @change="getBusiness($event)" hidden />
          <label class="change" for="business">
            <img src="../../assets/img/change.png" alt />修改
          </label>
        </li>
        <li v-if="false" class="icon">
          <label>确认书扫描件</label>
          <div class="icon-img">
            <img :src="cont.scanningCopy" alt />
          </div>
          <input type="file" id="scan" @change="getScann($event)" hidden />
          <label class="change" for="scan">
            <img src="../../assets/img/change.png" alt />修改
          </label>
        </li>
        <li v-if="false">
          <label>网站</label>
          <input type="text" placeholder v-model="cont.website" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
        <li v-if="cont.type != 1">
          <label>所在地</label>
          <input type="text" placeholder v-model="cont.address" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
        <li>
          <label>运营者姓名</label>
          <input type="text" placeholder v-model="cont.operatorName" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
        <li>
          <label>运营者身份证号</label>
          <input type="text" placeholder="请输入" v-model="idNumber" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
        <li class="icon" v-if="false">
          <label>运营者身份证照片</label>
          <div class="icon-img">
            <img :src="cont.operatorIdPic" alt />
          </div>
          <input type="file" id="Idpic" @change="getIdPic($event)" hidden />
          <label class="change" for="Idpic">
            <img src="../../assets/img/change.png" alt />修改
          </label>
        </li>
        <li>
          <label>联系电话</label>
          <input type="text" placeholder v-model="userPhone" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
        <li>
          <label>联系邮箱</label>
          <input type="text" placeholder v-model="cont.email" disabled />
          <div class="change">
            <img src="../../assets/img/change.png" alt />修改
          </div>
        </li>
      </ul>
      <div class="save-btn">
        <div class="btn-list active" @click="submitData">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import { spawn } from "child_process";
export default {
  data() {
    return {
      type: "",
      phone: "",
      cont: {
        id: "",
        accountName: "",
        accountIntroduce: "",
        accountPic: "",
        teamName: "",
        businessLicense: "",
        scanningCopy: "",
        website: "",
        address: "",
        operatorName: "",
        operatorIdNumber: "",
        operatorIdPic: "",
        bindPhone: "",
        email: "",
      },
      idNumber:'',
      userPhone:''
    };
  },
  mounted() {
    this.getData();
    this.getInfo();
    $(".change").click(function() {
      $(this)
        .parent()
        .children("input")
        .removeAttr("disabled")
        .addClass("active");
      $(this)
        .parent()
        .siblings()
        .children("input")
        .removeClass("active");
    });
  },
  methods: {
    getInfo() {
      this.$http
        .get("/api/user/007-getCusUserInfo", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(res, "账户设置");
          if (res.data.code == 0) {
            this.phone = res.data.rows[0].phone;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getData() {
      this.$http
        .get("/api/media/007--accountSetting", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(res, "账户设置");
          if (res.data.code == 0) {
            var len = res.data.rows.length - 1;
            this.cont = res.data.rows[len];
            var dataCont = res.data.rows[len];
            this.idNumber = dataCont.operatorIdNumber.substring(0,4)+'****'+ dataCont.operatorIdNumber.substring(14,18)
            this.userPhone = dataCont.bindPhone.substring(0,3)+'****'+ dataCont.bindPhone.substring(8,11)
            if (dataCont.type == 1) {
              this.type = "个人";
            }
            if (dataCont.type == 2) {
              this.type = "媒体组织";
            }
            if (dataCont.type == 3) {
              this.type = "国家机构";
            }
            if (dataCont.type == 4) {
              this.type = "企业机构";
            }
            if (dataCont.type == 5) {
              this.type = "其他组织";
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getHead(e) {
      //上传头像
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "http://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.cont.accountPic = res.data.url;
        }
      });
    },
    getBusiness(e) {
      //组织证书
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "http://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.cont.businessLicense = res.data.url;
        }
      });
    },
    getScann(e) {
      // 扫描件
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "http://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.cont.scanningCopy = res.data.url;
        }
      });
    },
    getIdPic(e) {
      //身份证照片
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "http://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.cont.operatorIdPic = res.data.url;
        }
      });
    },
    submitData() {
      var userIdNumber = '';
      if(this.idNumber.length == 18){
         userIdNumber = this.idNumber
      }else{
        userIdNumber = this.cont.operatorName
      }
      var userNumber = '';
       if(this.userPhone.length == 11){
         userNumber = this.userPhone
      }else{
        userNumber = this.cont.bindPhone
      }
      this.$http
        .get("/api/media/008-editAccountSetting", {
          params: {
            id: this.cont.id,
            accountName: this.cont.accountName,
            accountIntroduce: this.cont.accountIntroduce,
            accountPic: this.cont.accountPic,
            teamName: this.cont.teamName,
            businessLicense: this.cont.businessLicense,
            scanningCopy: this.cont.scanningCopy,
            website: this.cont.website,
            address: this.cont.address,
            operatorName: this.cont.operatorName,
            operatorIdNumber: userIdNumber,
            operatorIdPic: this.cont.operatorIdPic,
            email: this.cont.email,
            bindPhone: userNumber,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(res, "修改成功");
          if (res.data.code == 0) {
            this.$message("提交成功");
            this.$parent.$data.panelModal = false;
            this.$store.commit("leftNav", { index: 0 });
            this.$router.push({ path: "/iPage" });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.publish .save-btn {
  width: 140px;
}
</style>
<style>
input:disabled {
  background-color: #fff !important;
}
.el-button {
  padding: 0px !important;
  border-color: #2e8043 !important;
  color: #2e8043 !important;
  box-shadow: 0px 0px 0px 0px !important;
}
.el-button:hover {
  border-color: #2e8043 !important;
  color: #2e8043 !important;
  box-shadow: 0px 0px 0px 0px !important;
}
</style>